import { useCallback, useMemo } from 'react'

import { addMonths, endOfQuarter, format, getYear, startOfYear, subYears } from 'date-fns'

import { getYearMonthDayLocaleByDate } from '../../../../common/utils/utils'
import { useGetUtilizationQuartersQuery } from '../../../clients/clientDetails/data/utilizationApi'
import { PEMetricsQuarters } from '../data/platformEngagementApi'

const usePEQuarters = (
  { previousYear }: { previousYear: boolean } = { previousYear: false },
): PEMetricsQuarters | undefined => {
  const getStartAndEnd = useCallback(
    (startOfYearDate: Date, quarter: number) => ({
      start_date: format(addMonths(startOfYearDate, (quarter - 1) * 3), 'yyyy-MM-dd'),
      end_date: format(endOfQuarter(addMonths(startOfYearDate, (quarter - 1) * 3)), 'yyyy-MM-dd'),
    }),
    [],
  )

  const { data: utilizationQuarters } = useGetUtilizationQuartersQuery({
    date: getYearMonthDayLocaleByDate(
      previousYear ? new Date(getYear(new Date()) - 1, 11) : new Date(getYear(new Date()), 11),
    ),
  })

  return useMemo(() => {
    let startOfYearDate = startOfYear(new Date())

    if (previousYear) {
      startOfYearDate = subYears(startOfYearDate, 1)
    }

    const quarters =
      utilizationQuarters &&
      Object.entries(utilizationQuarters)
        .map(([quarterName, quarterDates]) => {
          return {
            start_date: quarterName === 'Q1_2025' ? format(new Date(2025, 0), 'yyyy-MM-dd') : quarterDates[0],
            end_date: quarterDates[1],
          }
        })
        .sort((quarter1, quarter2) => {
          return quarter1.start_date.localeCompare(quarter2.start_date)
        })
        .slice(1)
    return quarters
      ? {
          start_date: quarters[0].start_date,
          end_date: quarters[quarters.length - 1].end_date,
          quarters,
        }
      : undefined
  }, [getStartAndEnd, previousYear, utilizationQuarters])
}

export default usePEQuarters
